module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-performances/event-performances.component.scss
// module id = ./src/app/routes/event/event-performances/event-performances.component.scss
// module chunks = 9